import { render, staticRenderFns } from "./preview-online-answer-sheet-dialog.vue?vue&type=template&id=48bf1edc&scoped=true"
import script from "./preview-online-answer-sheet-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./preview-online-answer-sheet-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./preview-online-answer-sheet-dialog.vue?vue&type=style&index=0&id=48bf1edc&prod&scoped=true&lang=css"
import style1 from "./preview-online-answer-sheet-dialog.vue?vue&type=style&index=1&id=48bf1edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf1edc",
  null
  
)

export default component.exports